<template>
  <div class="sub-retailer-header">
    <h6>Dealers</h6>
    <div class="row">
      <div class="col-lg-4 col-md-12 col-12 align-items-center">
        <div class="row">
          <div class="col">
            <div class="input-group">
              <span class="input-group-text text-body">
                <i class="fas fa-search" aria-hidden="true"></i>
              </span>
              <input
                type="text"
                class="form-control"
                placeholder="Search Dealer"
                onfocus="focused(this)"
                onfocusout="defocused(this)"
                v-model="filter.keyword"
                @keyup="filterSubRetailers"
                :disabled="loading"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-8 col-md-12 col-12 d-flex justify-content-end align-items-center">
        <div
          class="icon-container-action text-dark d-flex align-items-center d-none" @click = "notImplemented"
          style="font-size: 13px"
        >
          <img src="/img/top-up.png" class="me-1" alt="logo" /> Top Up Dealer
          Balance
        </div>
        <div
          class="icon-container-action text-dark d-flex align-items-center d-none" @click = "notImplemented"
          style="font-size: 13px"
        >
          <img src="/img/transfercredittowallet.png" class="me-1" alt="logo" /> Transfer Rebate To Wallet
        </div>
        <button
          class="btn bg-gradient-dark mb-0 ms-3"
          @click="showSubRetailerDetail"
        >
          <i class="fas fa-plus me-1"></i>
          Add Dealer
        </button>
      
      </div>
    </div>

    <sub-retailer-users />
    <sub-retailer-user-detail />
    <sub-retailer-detail />
    <sub-retailer-balance />
    <sub-retailer-user-balance />
    <sub-settings />
    <sub-transactions/>

  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import subRetailerBalance from "./sidebar/subRetailerBalance.vue";
import subRetailerDetail from "./sidebar/subRetailerDetail.vue";
import subRetailerUsers from "./sidebar/subRetailerUsers.vue";
import subRetailerUserDetail from "./sidebar/subRetailerUserDetail.vue";
import subRetailerUserBalance from "./sidebar/subRetailerUserBalance.vue";
import subSettings from "./sidebar/subSettings.vue";
import subTransactions from "./sidebar/subTransactions.vue";

export default {
  components: {
    subRetailerDetail,
    subRetailerBalance,
    subRetailerUsers,
    subRetailerUserDetail,
    subRetailerUserBalance,
    subSettings,
    subTransactions,
  },
  computed: {
    ...mapState({
      filter: (state) => state.retailerController.subRetailerFilter,
    }),
  },
  methods: {
    ...mapMutations({
      setShowSubRetailerSidebar:
        "retailerController/SET_ShowSubRetailerSidebar",
      selectSubRetailer: "retailerController/SELECT_SubRetailer",
      filterSubRetailers: "retailerController/FILTER_SubRetailers",
    }),
    showSubRetailerDetail() {
      this.selectSubRetailer(null);
      this.setShowSubRetailerSidebar(true);
    },
    notImplemented() {
      alert("not yet implemented.");
    },
  },
};
</script>

<style></style>
